<template>
  <v-container>
    <v-dialog
        v-model="openFlag"
        hide-overlay
        persistent
        width="380"
    >
      <c-card class="white">
        <v-row justify="center" class="ma-5 title font-weight-bold">예약을 취소하시겠습니까?</v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="blue" large block @click="cancelDelivery(1)">예 (승객으로 인한 취소)</c-btn>
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="blue" large block @click="cancelDelivery(2)">예 (관리자에 의한 취소)</c-btn>
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="grey" large block @click="openFlag = false">아니오</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number | String,
      default: 380
    },
    deliveryId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      openFlag: false
    }
  },
  watch: {
    open(newVal) {
      this.openFlag = newVal;
    },
    openFlag(newVal) {
      this.$emit('update:open', newVal);
    },
  },
  methods: {
    cancelDelivery(type) {
      // 1: 무단취소, 2: 정상취소
      const deliveryState = (type === 1) ? 'dvry_user_cancel' : 'dvry_admin_cancel';
      const reqParam = {
        id: this.deliveryId,
        deliveryState: deliveryState
      };
      this.openFlag = false;
      this.$emit('reqCancelDelivery', reqParam);
    },
  }
}
</script>

<style scoped>

</style>